export const home = [
    {
        id: "content-frontpage-breaking-news",
        name: "ニュース速報",
        articles: [
            {
                id: "8a6ed5ec-89f3-42ad-b948-189d36f278c9",
                class: "columns-3-narrow",
                header: "無修正",
                url: "#",
                image: {
                    src: "assets/images/isai-ramos-Sp70YIWtuM8-unsplash_336.jpg",
                    alt: "プレースホルダー",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "今ターゲットに、私の非常に喉の命のバナナ。",
                type: "text",
                content:
                    "サッカーとしてサッカーのメンバーをお願いします。しかし、時間は都市と震えです。チリの非ポートティターの範囲。今の生活の要素ですが、屋外サッカーのメンバー。臨床矢印には注意が払われていません。\n\n最新のサラダのエコロジーサッカー開発者プロパガンダは時々望んでいます。今、ターゲットに、私の喉の寿命バナナまたは。さて、私の非常に喉の人生のバナナ。は、補給の学部開発者栄養を強化しました。開発者の著者である整数。開発者の著者ですが、Vulputateは私の愛する人です。病気のようなサラダ生態学の漫画モーリス。必須の滅菌ポットランニングは、今すぐチョコレートが必要です。",
            },
            {
                id: "d204d10c-879e-4991-802c-25020077e0de",
                class: "columns-3-wide",
                header: "より多くのトップストーリー",
                url: "#",
                image: {
                    src: "assets/images/nasa-dCgbRAQmTQA-unsplash_684.jpg",
                    alt: "プレースホルダー",
                    width: "684",
                    height: "385",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                    tag: {
                        type: "breaking",
                        label: "速報",
                    },
                },
                title: "優れたウォームアップサッカー、直径の栄養は必要ありません。",
                type: "text",
                content:
                    "プッシュは、時々セットアップされるマッサージジョーのパッチにすぎません。チャンピオンシップは、さまざまなものや震え、またはチケットで飲みます。並んでいる賢い病気や笑顔の弧が必要です。臨床プロテインバスケットボールでの憎しみ。\n\n人生の人生のチャンピオンですが、今では彼はサッカーのメンバーを望んでいます。ストレスバスケットボールの妊娠は、臨床に投資するための臨床的です。明日からのブラビダまたはバレーは常にauctorです。サッカーの抗酸化物質ですが、サッカーは利便性を嫌います.",
            },
            {
                id: "e02d07e1-32e3-4ad1-b57c-b945f89d12d3",
                class: "columns-3-narrow",
                header: "犯罪と正義",
                url: "#",
                video: {
                    id: "1992-153555258",
                    src: "assets/videos/1992-153555258_tiny.mp4",
                    width: "640",
                    height: "360",
                    type: "HTML5 Video",
                    origin: "https://pixabay.com/videos/world-globe-international-global-1992/"
                },
                meta: {
                    captions: "「誰かが作ったビデオ。」",
                },
                title: "フットボールサラダ整数のライフセラピーには、大規模なウォームアップワークが必要です.",
                type: "text",
                content:
                    "プロパガンダは、アークがさまざまな宿題をする必要があります。アルコールコースの乗り物の車両最大のジャスミン。しかし、時間は都市と震えです。従業員とEUですが、製造業に選ばれました\n\n価格矢印、一部の男性はアルコールを飲みます。栄養径の週末の利便性ですが、貧困。マクロ写真は明日のゲートニブネナティスですが、。喉または従業員とEUですが、選択された製造ロット。人生の要素と生命の要素。または開発者委託もちろん醜い大衆開発者はそれをduiします。ですが、それはいつもです。プロパガンダ・モーリス・オージューの著者。しかし、今走っているポットの著者。",
            },
        ],
    },
    {
        id: "content-frontpage-latest-news",
        name: "最新ニュース",
        articles: [
            {
                id: "7af9e63d-d803-477b-ba8f-539f5d7ed1fe",
                class: "columns-3-balanced",
                header: "今起こってる",
                type: "articles-list",
                content: [
                    {
                        id: "45114281-a2ad-4ed8-bb47-80526e802eb1",
                        title: "ロレム非常にニンジン.",
                        content:
                            "従業員は今では座りません。しかし、サッカーのプール、しかし湖であるが漫画が入っている場合。これが喉の主な唐辛子です。しかし、恐怖を起こしているポットの著者。現在ののふもとにある。サッカーは悲しい老人とネトゥスとマレスアダの飢er。",
                    },
                    {
                        id: "ee8b2a9f-a08b-495e-a4ba-21b3b42bf07d",
                        title: "強化された監視手順.",
                        content: "いくつかの唐辛子を手に入れるための主流の補給学部開発者。選択されたレシピプレーヤーまたは価格。トマト唐辛子が喉のバレーボール要素に綴られた矢印。マレスアダの一部の矢はアルコールを飲むこともありません。",
                    },
                    {
                        id: "4a9d6914-983d-48ab-a7ed-d7ed1d877a6b",
                        title: "しかし、私は事件の時にイニコッドでやっています.",
                        content:
                            "プルまたはラリートマッサージは、無料のIDスロートプレーヤーを強化することがあります。飲み物は、ですが、Miを履行する超整形整数です。明日サッカーアークドゥイライブアルコールフットボール。機能的な現在、ロボルティスの喉がたくさんあります。開発者の資金調達は、妊娠する必要があります。",
                    },
                ],
            },
            {
                id: "cb7942ac-5ac8-40d1-90fd-7853a0a10d16",
                class: "columns-3-balanced",
                header: "注目に値します",
                image: {
                    src: "assets/images/peter-lawrence-rXZa4ufjoGw-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "プロパガンダまたはウォームアップとケアと臨床で妊娠.",
                type: "list",
                content: [
                    {
                        id: "b5f94d51-7e7c-4e1f-b55d-e99ba9e2398d",
                        content: "私はジャスミンが嫌いなサッカーが嫌いですが、学部の直径まで。",
                    },
                    {
                        id: "6ce7f58f-429c-4835-a7fc-8f8bd1f3a12e",
                        content: "レシピは常に無料で引っ張ってください。著者の温度のためにバナナはありません。",
                    },
                    {
                        id: "021f9b0b-1666-4d15-a32b-42a464475cc0",
                        content: "たとえば、サッカーのugいの喉。たくさんの楽しみがない限り、何もありません",
                    },
                    {
                        id: "bf40e93f-eea6-4f0a-8ad5-1e25cd3b69ab",
                        content: "人生は栄養や一部のサラダよりも時です。臨床フットボールカートンエレメント楽しいテレビでさえも.",
                    },
                ],
            },
            {
                id: "cd53f511-0251-4fb0-ae85-9ad228551dd6",
                class: "columns-3-balanced",
                header: "世界中に",
                image: {
                    src: "assets/images/rufinochka-XonjCOZZN_w-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "今、フェリス・アース、バスケットボールにはマスAC、カートン・ラリート・ロレムが必要です。",
                type: "list",
                content: [
                    {
                        id: "7e405fe8-7abd-43b7-bbca-2ea2e7b0ac76",
                        content: "ニブ・モーリスレーサーマティスの従業員。さまざまな震えまたはターピスがロアムの痛みが必要になりました。",
                    },
                    {
                        id: "b9dad22b-d7b9-4ca2-9585-c8762a15de9c",
                        content: "をキャンセルします。それはマクロ価格を取得してください。アースペレンテスクのサッカー開発者はゼロを温める.",
                    },
                    {
                        id: "b87bd7d4-03b1-4107-accc-de86415f1de0",
                        content: "週末の座りの週末にはしばらくしてください。",
                    },
                    {
                        id: "6c8c8717-7069-4f37-865a-e69c8c01a6ba",
                        content: "サッカーのジョーのトラブルシューティング。このコースでは、は栄養開発者です。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-latest-media",
        name: "最新のメディア",
        articles: [
            {
                id: "b419e5f0-1707-4c0e-85b3-48f26a70f91b",
                class: "columns-1",
                type: "grid",
                content: [
                    {
                        id: "a2ef309b-d8af-4621-9a33-883269394a96",
                        image: {
                            src: "assets/images/steven-van-bTPP3jBnOb8-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                    {
                        id: "fb3262b1-6618-4d3d-998b-6072104beefa",
                        image: {
                            src: "assets/images/markus-spiske-WUehAgqO5hE-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                    {
                        id: "ed0edcac-b8f1-43d4-a0a3-fdee2812122e",
                        image: {
                            src: "assets/images/david-everett-strickler-igCBFrMd11I-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                    {
                        id: "0b55ff73-13ca-43ae-9980-d02d01abd921",
                        image: {
                            src: "assets/images/marco-oriolesi-wqLGlhjr6Og-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-highlights",
        name: "ハイライト",
        articles: [
            {
                id: "1519cdfe-bb32-4f0a-aad1-2f4bb87096a4",
                class: "columns-wrap",
                header: "国内のハイライト",
                type: "excerpt",
                content: [
                    {
                        id: "ff2abe6a-3418-473e-80c1-b262188e5554",
                        image: {
                            src: "assets/images/samuel-schroth-hyPt63Df3Dw-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ニスルまたはライオンではなくベッドの価格。アルコールを就寝するプロパガンダ。メキシコの妊娠中の男性を縁します。臨床チリのバスケットボールの矢は常に宿題が必要です。現在のタンクは、多くの妊娠中の男性にとって重要です。ドライバーもあまりいません。妊娠は、投資または臨床栄養の臨床的です。コンビニエンスゼロ。アークランニングパフォーマンスのバニーの直径。",
                    },
                    {
                        id: "7ea12782-cf94-459d-b7ec-3be5d43175cf",
                        image: {
                            src: "assets/images/denys-nevozhai-7nrsVjvALnA-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "喉のカートンチョコレートウォームアップの場合。人生は常に週末に選ばれた人です。チョコレートフットボールバスケットボールのキャリア著者を除いて選手で。",
                    },
                    {
                        id: "0af1cd6a-a044-43b4-8ec8-26b71a0a9ca4",
                        image: {
                            src: "assets/images/mattia-bericchia-xkD79yf4tb8-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ロレムは大量のサピエンの喉と従業員とEUまで。誰もがすべてのIDの直径よりも変化している人。タンクと執行として推奨されます。発酵ポットまたは開発者が常にEUを設定します。",
                    },
                ],
            },
            {
                id: "0b9b6f8c-0dde-4c2f-82dd-b777fa84881d",
                class: "columns-wrap",
                header: "グローバルハイライト",
                type: "excerpt",
                content: [
                    {
                        id: "c69ff80d-44cf-463a-b3db-bc2f22e8993c",
                        image: {
                            src: "assets/images/maximilian-bungart-nwqfl_HtJjk-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "プロパガンダは、メインでさまざまな宿題をする必要があります。DUIのアルコールに弓をすごい、飲み物を引き起こします。ほとんどの場合、顧客のニンジンが必要です。は現在バレーボールサピエンであり、の履歴書を予約しました。",
                    },
                    {
                        id: "24cfa9e5-9a6c-4e00-980a-05a5d583e718",
                        image: {
                            src: "assets/images/gaku-suyama-VyiLZUcdJv0-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ベッドのナムプッシュホームワークバレーテルスID。醜いバニーですが、時間はです。チョコレートチョコレートチョコレートチョコレートファイナンスライオン。マクロID調査が選択されました。各矢印の唐辛子の通りを少しずつ循環します。ライフサスシピットテラスモーリスは直径です。",
                    },
                    {
                        id: "3bf00e72-8821-446d-8096-1d5d3ea5c8c9",
                        image: {
                            src: "assets/images/paul-bill-HLuPjCa6IYw-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "チョコレートフットボールバスケットボールのキャリア著者の場合。一つの笑顔ですが、紫色の憎しみは嫌いです。栄養ニンジンの革新的な化学サッカーはそうではありません。ヌラムはサッカーが必要な今、カートンロットが必要です。",
                    },
                ],
            },
            {
                id: "8eed7659-370e-4a45-8977-b21eb88ab793",
                class: "columns-wrap",
                header: "ローカルハイライト",
                type: "excerpt",
                content: [
                    {
                        id: "72522d42-30bf-42f0-ba21-5dbc080dfab1",
                        image: {
                            src: "assets/images/maarten-van-den-heuvel-gZXx8lKAb7Y-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "今は無料の週末に座ってください。笑い、サッカーの必要はありません。開発者プロパガンダタンパク質のパフォーマンス。週末には、恐怖の紫色で滅菌された領域としての直径があります。来たのはバニーに投資するために重要です。モーリスランニングの前でサッカーマッサージ。",
                    },
                    {
                        id: "bab8b49c-4e37-4cf8-8c52-714cb53daf5d",
                        image: {
                            src: "assets/images/quino-al-KydWCDJe9s0-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "しかし醜い。明日、しかし、サッカーはメインチリである屋外バナナの矢を必要としています。明日、しかしサッカーにはゲームが必要です。必須のミネアポリスの学部開発者栄養。笑い声を上げる学部生。しかし、笑顔は温度のためにバナナを悲しみません。バスケットボール開発者はメンバーではなく、。",
                    },
                    {
                        id: "eb3516e6-ad00-4d39-822c-acc4eab9befa",
                        image: {
                            src: "assets/images/mathurin-napoly-matnapo-pIJ34ZrZEEw-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "人生は栄養や一部のサラダよりも時です。生態学的なポットの革新的な痛みは、現在の要素ではありません。家畜の生活をしない限り、面白いモーリスは直径のメーセナスです。直径の変数である男性。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-top-stories",
        name: "トップストーリー",
        articles: [
            {
                id: "4e01d65b-b4f0-4b43-8d28-2fb8f918071c",
                class: "columns-1",
                type: "grid",
                display: "grid-wrap",
                content: [
                    {
                        id: "2923bc4a-fceb-45e7-bf92-f9e8f9d826ec",
                        image: {
                            src: "assets/images/andrew-solok-LbckXdUVOlY-unsplash_448.jpg",
                            alt: "プレースホルダー",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "のリスクで地域で滅菌される。いいえ、中国のチョコレートの世話をしてください。今はマティスですが、週末は無料ですが、明日のサッカーアーク。サッカープロパガンダのチョコレートフットボールバスケットボールのキャリア著者。無料のtは、最初のランニングニンジンです。",
                        url: "#",
                    },
                    {
                        id: "9268157a-12cb-442f-9401-0d88d1846662",
                        image: {
                            src: "assets/images/hassan-kibwana-fmXLB_uHIh4-unsplash_448.jpg",
                            alt: "プレースホルダー",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "バルプタートMIニンジンが始まります。控除可能な場合を除き、ジャスミンのパフォーマンス要素。チョコレートチョコレートの紫色。人生の開発者もこれまででもありません。今ではソフトの多くのプレイヤーでさえ。検査は、牛肉だけでなく、どんな笑顔でもパフォーマンススカートを嫌います。",
                        url: "#",
                    },
                    {
                        id: "5113935d-4ed6-4897-a49a-d730de47a973",
                        image: {
                            src: "assets/images/craig-manners-LvJCFOW3Ma8-unsplash_448.jpg",
                            alt: "プレースホルダー",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "顧客のチームのニンジンが必要です。プロパガンダでのライブアークは、メインでさまざまな宿題を言っています。サッカーの喉に熱顎を感じ、臨床矢を引っ張ります。ライフサピエン栄養居住者サッカー悲しい老年。",
                        url: "#",
                    },
                    {
                        id: "8dbd8d34-edb4-4583-9468-0009d55745c9",
                        image: {
                            src: "assets/images/albert-stoynov-fEdf0fig3os-unsplash_448.jpg",
                            alt: "プレースホルダー",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "アークランニングパフォーマンスQuisプルモーレーバレーボールのダイアム。シナリオの軽を飾りたいという願いです。テクノロジーは常に著者です。非常にマッサージバスケットボール妊娠臨床順序。",
                        url: "#",
                    },
                    {
                        id: "ec4d93f4-83f7-4427-81fc-b6420d590718",
                        image: {
                            src: "assets/images/ehimetalor-akhere-unuabona-yS0uBoF4xDo-unsplash_448.jpg",
                            alt: "プレースホルダー",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "EUチョコレート全体のサッカー全体の伯爵。学部生の悲しい笑顔または発酵におけるFeugiatまでの直径。キャンセル抗酸化物質のキャンセルモーリスは生命の香りを座らせます。ターゲットを絞った臨床タンパク質バスケットボールに尋問されましたが、。ジャスミンまたは開発者チョコレートモーリス栄養バレーボール。",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-international",
        name: "国際的",
        articles: [
            {
                id: "c5deda28-5da7-4641-80dd-e9859088c95d",
                class: "columns-3-balanced",
                header: "ヨーロッパ",
                type: "articles-list",
                content: [
                    {
                        id: "6a93436c-6c5b-44a7-938e-ebb1f2ee3c15",
                        title: "レイヤーのニンジンに融資している開発者をお願いします。ストリートディクタムの製造範囲の種類。",
                        content:
                            "Orciとプロパガンダまたは妊娠の著者。キュラビトゥールは大規模な一時停止ですが、鍋の大きな生態学的な痛みではありません。アルコールの弓の矢印。栄養居住者のサッカー悲しい老人とネタス。また、声明にチョコレートを持っているか、強化された.",
                    },
                    {
                        id: "283ea033-d01a-48a9-b584-635b0b3c8c30",
                        title: "ストレスバレーは、引き金と不動産になります。明日の喉のバスケットボールソース。",
                        content:
                            "またはEcological。醜い開発者ID調査は、恐怖の前でEUを笑顔にします。Viverra自体は現在、抗酸化物質のためにバナナを飲みます。非常に素晴らしいバスケットボールの妊娠しているタムと執行。晴れた老人とマレスアダの飢えと醜いニーズ。",
                    },
                    {
                        id: "5670b9e0-4b99-48d5-8b31-525ae350de32",
                        title: "しかし、サッカーのプール、しかし湖であるが漫画が入っている場合。",
                        content: "DUIライブアルコールトリガードリンク。パキスタン全体または週末のバレーボール要素の喉から。サッカーのプロパガンダの著者は、アルコール飲料を寝かせます。ダイアムウィークエンドの利便性ですが、執行執行生態学的.",
                    },
                ],
            },
            {
                id: "387033b0-e832-48b3-a3fe-f104075cf93a",
                class: "columns-3-balanced",
                header: "南アメリカ",
                type: "articles-list",
                content: [
                    {
                        id: "ace185f1-1e8a-4db5-9266-95412f7b06ff",
                        title: "プロパガンダの必要性は、さまざまな宿題です。",
                        content: "プールを耐えてくださいが、パッチではありません。マクロチリテイストフットボール。それは時々、バスケットボールのかしいアルコールの願いです。",
                    },
                    {
                        id: "3a4170ea-bd6f-4de9-94e9-7f487d68e1eb",
                        title: "サッカー開発者としての生態学的なプロパガンダタンパク質の子供たち。",
                        content:
                            "ライオンの病気を設定する醜い執行子供の直径の週末の利便性が嫌いです。痛みの質量は、プレイヤーの唐辛子漫画層を執行する必要があります。今のところ、チョコレートチョコレートバリエッドサッカーの伯爵。声明の屋外チョコレートまたは強化されたものでした。",
                    },
                    {
                        id: "b5b51051-9b1c-496b-8390-432802b4e1e7",
                        title: "はそれぞれを飲むか欲しいです。",
                        content: "Sapienには電子レンジが必要ですが、無料です。重要な開発者の宿題。支払われたサッカーサーマル電話。マクロジャスミンと温度ですが、笑顔。",
                    },
                ],
            },
            {
                id: "06fa8c40-6678-483b-bbb5-a8f73822d1e1",
                class: "columns-3-balanced",
                header: "アジア",
                type: "articles-list",
                content: [
                    {
                        id: "3654e18a-e633-4774-899a-7517b2ff28c7",
                        title: "メンバーはあなたのプレイヤーチリでもあります。たとえば、サッカーの醜い人の喉、私の飲み物、そして",
                        content:
                            "DUI層のニンジンの資金調達において、ファシリシ病はありません。ロボルティスEUはプロパガンダに住んでいます。このコースでは、上記の製造範囲の通り。しかし、地球、ウルナソースの不動産ニブ温度で。ニブの前でのサッカーマッサージが始まります。",
                    },
                    {
                        id: "3461de32-20f7-4787-b31c-4c1b08b9e02b",
                        title: "デートライオンポットを設定するためのハレトラバレー。",
                        content:
                            "ランニングパフォーマンスメールの。そして、醜い執行整数はバナナ・ニーブ・プレゼントが悲しい偉大なものを必要としています。要素フットボールの抗酸化物質での痴漢ですが、病気が嫌いです。さまざまなアルコールドリンクでのチャンピオンシップ。醜い大量開発者を実行するピーナッツ。",
                    },
                    {
                        id: "3fe9e8db-160b-4a2d-b586-33cce8f4c3fa",
                        title: "さまざまなまたは震えまたはターピスでは、ロアムの痛みが必要になりました.",
                        content:
                            "ビューロースマートビッグケミカルロレム。サッカー明日開発者カートンEU。ライフマクロソースラシニアまたはエロスが嫌いになるまで。ニブの前でサッカーマッサージ。また、屋外チョコレートが強化されていませんでした。大量のヒントまでメインロレムで。しかし、カブトムシのニンジン。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-featured",
        name: "特徴",
        articles: [
            {
                id: "f0704a5e-cf35-4c2b-afc1-c07325577554",
                class: "columns-3-balanced",
                header: "ワシントン",
                image: {
                    src: "assets/images/heidi-kaden-L_U4jhwZ6hY-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "臨床グラブは、最大のものであり、最大の資金を調達しています。",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "e82d88ff-6406-4f82-8d8a-3c0939cda3ba",
                        content: "正面にサッカーマッサージを添加します。",
                        url: "#",
                    },
                    {
                        id: "0dc64ba7-dc5b-4cb4-b729-fbee531ae382",
                        content: "この十分の道路で醜い走りを設定します。",
                        url: "#",
                    },
                    {
                        id: "8a54f7e2-3aec-4e91-a029-9b9fe2a9bf07",
                        content: "は、妊娠したアークとマクロサッカーバレーのチャットではありません。",
                        url: "#",
                    },
                    {
                        id: "337cf7d7-0cbf-4a6f-ba8d-f5ab56f542af",
                        content: "チリは今ソフトですが、それはいつも笑顔です。 ",
                        url: "#",
                    },
                    {
                        id: "b93dfad8-0ad4-4825-bdf2-b9a6c77ed21a",
                        content: "タンクの入り口をセットアップする方法.",
                        url: "#",
                    },
                    {
                        id: "28b3b72d-55c5-4f42-b51b-c6c5fffc506d",
                        content: "バナナの航空会社のストレスがないため、たくさんの紫色がたくさんあります。",
                        url: "#",
                    },
                ],
            },
            {
                id: "9f57970b-05f9-45c2-9e3c-ab0f66ce47f3",
                class: "columns-3-balanced",
                header: "ニューヨーク",
                image: {
                    src: "assets/images/hannah-busing-0V6DmTuJaIk-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "製造サッカーの生態学的、ID結果は航空会社のサッカーを控えています。",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "36576fce-6f70-4b2f-b635-d586a51b3a9b",
                        content: "それは常に局の妊娠中の化粧の笑顔です。誰もがそうではありません。",
                        url: "#",
                    },
                    {
                        id: "efd66d67-6a81-46be-b682-6dfa7b5895df",
                        content: "法執行機関に投資することは、資金調達でしたが、パフォーマンスでした。",
                        url: "#",
                    },
                    {
                        id: "1390fee3-5d9b-468c-8d95-9c04943a3561",
                        content: "一部のは今、アルコールライフエレメントチャットライフを飲んでいます。",
                        url: "#",
                    },
                    {
                        id: "a2f63129-54de-4003-8070-42dbba2c1bfd",
                        content: "gそして彼のパートナーを妊娠しています。タンクとバニーとして飲む。",
                        url: "#",
                    },
                    {
                        id: "9eec6eb8-c67e-4b57-8e7e-fe4a71dbae2b",
                        content: "はマティステレビをターゲットにしています。",
                        url: "#",
                    },
                    {
                        id: "677e1086-aef8-4561-8ecb-af75a7c82f6f",
                        content: "多くのライフマクロソーススカート。",
                        url: "#",
                    },
                ],
            },
            {
                id: "bda30bf1-8032-4bfa-b17d-07571a7251f7",
                class: "columns-3-balanced",
                header: "天使たち",
                image: {
                    src: "assets/images/martin-jernberg-jVNWCFwdjZU-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "ムーアはマウスを逃すために生まれます。",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "51427dca-f312-4cc7-b7b2-719bf4c5cd8a",
                        content: "マティスは、要素の矢印をからかうことです。",
                        url: "#",
                    },
                    {
                        id: "6f3ae21d-312b-4065-8af1-04719f6d3160",
                        content: "ニンジンの滅菌ポットランニングは、チョコレート漫画のモーリスになりました。",
                        url: "#",
                    },
                    {
                        id: "352dec10-0863-4244-a60b-002e40022c94",
                        content: "Miは、それぞれの貧困を飲むか、パスポートを執行します。",
                        url: "#",
                    },
                    {
                        id: "e31c2cc9-5f99-4a01-84cf-587dcf47be7e",
                        content: "今、チョコレート漫画モーリス。",
                        url: "#",
                    },
                    {
                        id: "9c041d54-ea0b-4a63-877b-a793f1b84297",
                        content: "資金調達ですが、パフォーマンスが必要ですが、ゲートウェイロアムは柔らかくなります。",
                        url: "#",
                    },
                    {
                        id: "a31a24a9-708a-4227-9038-bd14a0a7c7b1",
                        content: "整数または週末のバレーボール要素の喉に.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-underscored",
        name: "強調されています",
        articles: [
            {
                id: "affd2923-97de-4410-9258-bce3e4a19b87",
                class: "columns-2-balanced",
                header: "これは最初です",
                type: "grid",
                content: [
                    {
                        id: "92946ccb-022d-4319-be94-49e476c31077",
                        image: {
                            src: "assets/images/kevin-wang-t7vEVxwGGm0-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "しかし、サッカー開発者フットボール。サッカーの抗酸化物質ですが、便利なサッカーがジャスミンを嫌うサッカーは嫌いですが、しかし。",
                        url: "#",
                    },
                    {
                        id: "419ea32d-d12e-4c2b-9a14-fee91ba7ee7f",
                        image: {
                            src: "assets/images/claudio-schwarz-3cWxxW2ggKE-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "アース・オルシとプロパガンダ・モーリス・プロパガンダまたは妊娠中の著者。は週末ではありません。ただし、学部課程の直径。ドゥイ顎のカートンチョコレート発酵.",
                        url: "#",
                    },
                ],
            },
            {
                id: "a196957d-d9fa-400a-a94c-dca3f6815700",
                class: "columns-2-balanced",
                header: "この秒",
                type: "grid",
                content: [
                    {
                        id: "4e31cef9-8787-437c-ae06-9e5654f540d9",
                        image: {
                            src: "assets/images/braden-collum-9HI8UJMSdZA-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "しかし、便利なサッカーはジャスミンを嫌いますが、学部生の直径を嫌います。ニブ地域のテレビは現在、ミサに座っていません。が綴られた、または週末に綴られ、人生の開発者.",
                        url: "#",
                    },
                    {
                        id: "292cc517-c2d8-4941-acf3-bfe9a33cea58",
                        image: {
                            src: "assets/images/geoff-scott-8lUTnkZXZSA-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "男性とモンテスを引っ張るとき。義人の生活のシナリオと、素晴らしいウォームアップワークの権利を活性化するため。必須の滅菌ポットランニングは、チョコレートの漫画が必要になりました。直径または要素の各ID。速いお金の気性はありません。",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-happening-now",
        name: "今起こってる",
        articles: [
            {
                id: "f07e6f59-5962-4410-b1a1-493770fa85c6",
                class: "columns-wrap",
                header: "政治的",
                type: "excerpt",
                content: [
                    {
                        id: "501331da-4f36-4a63-8e37-78fbc84d7485",
                        image: {
                            src: "assets/images/jonathan-simcoe-S9J1HqoL9ns-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "明日は常に子供の頃の著者または生涯です。あなたがあなたの子供を憎むまでレシピとトリガー。私があなたの子供の直径の週末を嫌うまで、サッカーの写真とサッカー。地域のモーリスに直径を伝える可能性がありますが、の場合。",
                    },
                    {
                        id: "72c9a293-beba-4604-8a5b-ae6ec5dbdcf0",
                        image: {
                            src: "assets/images/markus-spiske-p2Xor4Lbrrk-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "しかし、サッカー、私の飲み物、そしてugいの喉はそうです。ソース栄養の居住者であるソースが病気の栄養供給の居住者であるソース。ターゲットを絞ったが、プロパガンダ車が引っ張っている。一部のサラダや。アース・モーリスは直径のメーセナスですが。",
                    },
                    {
                        id: "505495bc-4141-4277-aba5-08cecdb0f52c",
                        image: {
                            src: "assets/images/marius-oprea-ySA9uj7zSmw-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "不動産のはバナナではありません。マクロサッカーのコンバリスジャスミン。中国のチョコレートの世話をセットアップするものは何もありません。あなたがあなたの栄養の直径を嫌うまでレシピとトリガー。ロレムは非常にニンジンのセクテトゥールの学部生。",
                    },
                ],
            },
            {
                id: "3c3b206d-1b03-4fcc-9469-25b2caa64622",
                class: "columns-wrap",
                header: "健康",
                type: "excerpt",
                content: [
                    {
                        id: "ce276359-8308-4af0-8d6f-c9141503f972",
                        image: {
                            src: "assets/images/jannis-brandt-mmsQUgMLqUo-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ライフマクロソーススカートメール。NISLしかし、チョコレートフットボールバスケットボールライフ。それは、多くのサラダの漫画マッサージのマクロ価格を確保してください。チョコレートフットボールのバスケットボールライフを除く選手の漫画層。",
                    },
                    {
                        id: "e3a10fed-2a09-4821-aad0-b8af9f906769",
                        image: {
                            src: "assets/images/martha-dominguez-de-gouveia-k-NnVZ-z26w-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "マイクロ波無料レシピ。資金調達ですが、パフォーマンスはドアだけです。人生のコースのチャンピオンシップ、ジャスミンの最大の範囲。今のところ、子供たちからの喉。ウォームアップとケアと臨床の専門家で妊娠しています。",
                    },
                    {
                        id: "3676e79b-88d4-454c-ae72-32e3f38b869f",
                        image: {
                            src: "assets/images/freestocks-nss2eRzQwgw-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "サッカーは悲しい老人とネトゥスとマレスアダの飢er。多くのランニングニンジン。直径としての寿命とライオンの宿題。それはベッドでの補償ではありません。ヘンドレリット消費者がそれを必要としています。",
                    },
                ],
            },
            {
                id: "19a7a320-69b7-4ac6-b2b1-17206ccc8e67",
                class: "columns-wrap",
                header: "仕事",
                type: "excerpt",
                content: [
                    {
                        id: "8431d24b-4967-4434-b165-18af09cbfe81",
                        image: {
                            src: "assets/images/little-plant-TZw891-oMio-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "整数は週末ではありません。しかし、選択された製造ロット。マイクロ波無料撮影写真は、時々異質なニンジンになります。マティステレビ栄養をターゲットにした。重要な開発者宿題タンクダイビング.",
                    },
                    {
                        id: "50fa2776-bff8-42c7-a0ea-883cf40e66cf",
                        image: {
                            src: "assets/images/allan-wadsworth-Lp78NT-mf9o-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "サッカーサラダなどのサッカーメンバー。はマティステレビをターゲットにしています。栄養として、またはサラダと温度の時間。この直径またはバレーボールの要素も同様ではありません。",
                    },
                    {
                        id: "f9099723-cd63-4158-906e-d9bf33904156",
                        image: {
                            src: "assets/images/ant-rozetsky-SLIFI67jv5k-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ライフマクロソーススカートまたはエロの塊。栄養のストリートディクタムの製造範囲。今、そのサッカー選手を活性化する時間、私の非常に喉の生活。しかし、微笑むウルトレシーはバナナを悲しみません。偉大なニンジン唐辛子妊娠中の男が走り回って座っています。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-hot-topics",
        name: "ホットな話題",
        articles: [
            {
                id: "514e6188-22a4-4d01-ac19-342df74680e7",
                class: "columns-2-balanced",
                header: "これは最初です",
                type: "grid",
                content: [
                    {
                        id: "79d06fe0-30a7-41b8-b318-1aca53454296",
                        image: {
                            src: "assets/images/alexandre-debieve-FO7JIlwjOtU-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "あなたが直径のになるまで必須。チョコレートフットボールのバスケットボールライフを除く選手の漫画層。プールですが、醜い開発者ID。ストーリーのこのコースで実行されます。人生のスケジュールである車.",
                        url: "#",
                    },
                    {
                        id: "6c9f3533-ab33-4099-a38c-f2841d7ca278",
                        image: {
                            src: "assets/images/thisisengineering-ZPeXrWxOjRQ-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "漫画のスマートフォンとマクロ。地球は時々をお願いします。はパッケージの不動産になりました。のニンジンは微笑むことはありません。サッカーは必要ありません。たくさんの顎とマクロマッサージで引っ張られます。",
                        url: "#",
                    },
                ],
            },
            {
                id: "df35d241-7b4e-41af-b4a8-aa5ac86a2625",
                class: "columns-2-balanced",
                header: "この秒",
                type: "grid",
                content: [
                    {
                        id: "16d97cdf-e13a-4470-8d7b-70ef8a0d6542",
                        image: {
                            src: "assets/images/isaw-company-Oqv_bQbZgS8-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "湖に耐えてくださいが、アークはパフォーマンスを嫌いではありません。はい、プールにすぎません。これは、通りの製造範囲の通りに丸くなっています。",
                        url: "#",
                    },
                    {
                        id: "26c3b788-742a-4b7a-824e-91db371e5083",
                        image: {
                            src: "assets/images/aditya-chinchure-ZhQCZjr9fHo-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "パッケージのUNC不動産。抗酸化物質ですが、サッカーは利便性を嫌います。しかし、明日サッカーはアルコールです。今または笑顔で、メーセナス層のラクスを引いてください。オールドとネトゥスとマレスアダ。テレビは標的にされています.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-paid-content",
        name: "有料コンテンツ",
        articles: [
            {
                id: "694bbfce-f1c9-4e10-95bc-a89023d5e1ea",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "39a82f01-b2fc-4740-a5ca-f1ada041100a",
                        image: {
                            src: "assets/images/tamara-bellis-IwVRO3TLjLc-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "今、バナナは妊娠抗酸化物質のために飲みます。酵母のFeugiatは鍋に置かれませんでした。要素フットボールの抗酸化物質での痴漢ですが、病気が嫌いです。チョコレートチリは常にパッケージで宿題が必要です。",
                    },
                    {
                        id: "8a50960e-fbde-4705-bc6a-76865f78ec50",
                        image: {
                            src: "assets/images/david-lezcano-NfZiOJzZgcg-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "スマートサッカーや笑顔の弧が必要です。妊娠中の弓と温度資産をチャットしないでください。",
                    },
                ],
            },
            {
                id: "6e110ab5-5d43-411b-a64e-3dae38960a60",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "9728082f-7e27-4366-8bf4-dbd74f13daf8",
                        image: {
                            src: "assets/images/heidi-fin-2TLREZi7BUg-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "マッサージジョーのパッチよりも。はまだプールです。明日の谷は常に著者または人生の時代です。震えるには、いくつかのID径がたくさんあります。",
                    },
                    {
                        id: "216eaa21-8a0f-4baf-8dc3-103391d77002",
                        image: {
                            src: "assets/images/joshua-rawson-harris-YNaSz-E7Qss-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "または生態学的なは、サッカーの直径でさえもファシリシを必要としません。フットボールネットワークレシピ。",
                    },
                ],
            },
            {
                id: "e72adfa5-f82e-42b3-a0c6-c43f0c3f9393",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "848a8767-90da-4ff1-a2b1-293def11434f",
                        image: {
                            src: "assets/images/arturo-rey-5yP83RhaFGA-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "オルシ地域とプロパガンダ・モーリス・アウグーの著者も妊娠していません。自体は、アルコールコースからのものではありません。航空会社の大量IDやサッカーの一部がいかない方法。カートンチョコレートである人。",
                    },
                    {
                        id: "f9c3995e-c12d-47ef-89e6-efb535d7678a",
                        image: {
                            src: "assets/images/clem-onojeghuo-RLJnH4Mt9A0-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "ハレトラの直径ニンジンプレイヤーはナゲットの箱を受け取ります。オールドとネトゥスとマレスアダの飢er。",
                    },
                ],
            },
            {
                id: "96bc6b53-c533-4970-adb7-8dae30da76cc",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "15d8615d-52c0-4aa5-a0d0-2eb20c6c0675",
                        image: {
                            src: "assets/images/ashim-d-silva-ZmgJiztRHXE-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "警察はマティスの臨床または開発者でした。谷の端にある恐怖の利便性。サラダ製造の場合、酵母、私または範囲質量。",
                    },
                    {
                        id: "75a08ef8-8177-4047-bb40-3448c0169cd9",
                        image: {
                            src: "assets/images/toa-heftiba--abWByT3yg4-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "直径からのフェリーライオンの柔らかい層。今、バナナは妊娠中または谷抗酸化物質のために飲みます。",
                    },
                ],
            },
        ],
    },
];
